<script setup lang="ts">
import UiPill from '@@/lib/ui-toolkit/components/UiPill.vue';
import { computed } from 'vue';
import { useRuntimeConfig } from '#app';

const statusLabels = {
  beta: 'Public Beta',
  dev: 'Dev Preview',
} as const;

// no need for a computed since this is set at build time
const {
  envStatus = 'dev',
} = useRuntimeConfig().public;

const label = computed<string>(() => statusLabels[envStatus as keyof typeof statusLabels] || statusLabels['dev']);
</script>

<template>
  <UiPill :variant="envStatus === 'beta' ? 'default' : 'warning'">
    {{ label }}
  </UiPill>
</template>

<style scoped lang="scss">

</style>
